import { Button, Tabs } from "@heroui/react";
import { GitFork, House, Plus, User } from "lucide-react";
import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const ROUTES = {
  home: { key: "home", icon: House, route: "/", label: "Home" },
  network: { key: "network", icon: GitFork, route: "/network", label: "Network" },
  profile: { key: "profile", icon: User, route: "/profile", label: "Profile" },
};

const routesArr = Object.values(ROUTES);

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedTab, setSelectedTab] = useState("home");

  useEffect(() => {
    const match = routesArr.find(
      (r) => r.route === location.pathname || (r.key === "home" && (location.pathname === "/" || location.pathname === "/upcoming" || location.pathname === "/past"  ))
    );

    console.log(match)
    if (match) setSelectedTab(match.key);
  }, [location.pathname]);

  const handleSelectionChange = (key) => {
    const tabKey = String(key);
    setSelectedTab(tabKey);
    const target = ROUTES[tabKey];
    if (target) navigate(target.route);
  };

  return (
    <div className="navbar max-w-[320px] mx-auto p-1 px-2 flex items-center justify-between rounded-full bg-background/50 dark:bg-[#1E1E1ED9] dark:border-[2px] dark:border-white/20">
      <Tabs className="grow shadow-none h-full" selectedKey={selectedTab} onSelectionChange={handleSelectionChange}>
        <Tabs.ListContainer className="bg-transparent w-full">
          <Tabs.List className="bg-transparent w-full flex" aria-label="Primary navigation">
            {routesArr.map(({ icon: Icon, label, key }) => (
              <Tabs.Tab
                key={key}
                id={key}
                className="flex flex-1 bg-transparent flex-col items-center py-2 min-h-[40px] h-full text-muted text-xs data-[selected]:text-glass-foreground"
              >
                <Icon size={16} className="min-w-4 min-h-4" />
                <span className="font-normal">{label}</span>
                <Tabs.Indicator className="bg-accent" />
              </Tabs.Tab>
            ))}
          </Tabs.List>
        </Tabs.ListContainer>
      </Tabs>

      <Button isIconOnly onPress={() => navigate("/meetings/new")} aria-label="Create meeting" className="quick-meets-btn h-[44px] w-[44px]">
        <Plus />
      </Button>
    </div>
  );
};

export default Navbar;